export enum ZoneLabel {
  Yes = 'YES',
  No = 'NO',
  Unknown = 'UNKNOWN',
}
